<template>
  <v-main
    :style="{
      'background-image': 'url(' + require('../../assets/adtbg3.png') + ')',
      'background-position': 'center',
      'background-repeat': 'no-repeat',
      'background-size': 'cover',
    }"
  >
    <!-- <v-main> -->
    <v-container fluid fill-height>
      <v-layout align-center justify-center>
        <v-flex xs12 sm8 md5>
          <h2
            style="
              font-family: cursive;
              font-style: italic;
              text-align: center;
              font-size: 27px;
              color: #fff;
            "
          >
            {{ settings && settings.shop ? settings.shop.name : "Adeton POS" }}
          </h2>

          <v-card class="elevation-1">
            <v-toolbar color="blue-grey darken-4">
              <v-toolbar-title style="color: white">Login</v-toolbar-title>
              <v-spacer></v-spacer>
              <!--<v-tooltip bottom>
                  <v-btn
                    icon
                    large
                    :href="source"
                    target="_blank"
                    slot="activator"
                  >
                    <v-icon large>code</v-icon>
                  </v-btn>
                  <span>Source</span>
              </v-tooltip>-->
            </v-toolbar>
            <v-card-text>
              <v-form v-model="valid" :lazy-validation="lazy" ref="form">
                <v-text-field
                  prepend-icon="vpn_key"
                  v-model="shop_access_key"
                  name="shoplink"
                  label="Shop Access Key"
                  type="text"
                  :rules="valid_rules.shoplinkRules"
                ></v-text-field>
                <v-text-field
                  prepend-icon="person"
                  v-model="auth.email"
                  name="login"
                  label="Email"
                  type="text"
                  :rules="valid_rules.emailRules"
                ></v-text-field>
                <v-text-field
                  prepend-icon="lock"
                  v-model="auth.password"
                  name="password"
                  label="Password"
                  id="password"
                  type="password"
                  :rules="valid_rules.passwordRules"
                  @keydown.enter="signin()"
                ></v-text-field>
              </v-form>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn :loading="loading" color="primary" @click="signin()"
                >Login</v-btn
              >
              <!--<v-btn color="primary" @click="setLayout('simple-layout')">Simple Layout</v-btn>
              <v-btn color="secondary" @click="setLayout('admin-layout')">App Layout</v-btn>-->
            </v-card-actions>
          </v-card>
        </v-flex>
      </v-layout>
      <snackbar ref="sb"></snackbar>
    </v-container>
  </v-main>
  <!--<v-container fluid fill-height>
    <v-layout align-center justify-center>
     
    </v-layout>
  </v-container>-->
</template>



<script>
import snackbar from "../shared/snackbar";
//import AuthService from "../../services/auth-service";
import { mapGetters } from "vuex";
import axios from 'axios'

export default {
  components: {
    snackbar,
  },
  data() {
    return {
      shop_access_key: "",
      valid: true,
      lazy: false,
      valid_rules: {
        shoplinkRules: [
          (v) => !!v || "Shop Access Key is required",
          // v => v.length <= 10 || 'Name must be less than 10 characters',
        ],
        emailRules: [
          (v) => !!v || "E-mail is required",
          (v) =>
            /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(v) ||
            "E-mail must be valid",
        ],
        passwordRules: [
          (v) => !!v || "Password is required",
          // v => v.length <= 10 || 'Name must be less than 10 characters',
        ],
      },
      auth: {
        email: "",
        password: "",
      },
      shoplink: "",
      shopAccessDetails:{},
      dialog: false,
    };
  },

  methods: {
    signin() {
      //console.log(navigator);
      
      if (this.$refs.form.validate()) {
        // localStorage.shoplink = this.shopAccess.shoplink;
        this.setShopDetails()
        this.$store.dispatch("Auth/login", {
          email: this.auth.email,
          password: this.auth.password,
          shoplink: this.shopAccessDetails?.shoplink
        });
      }
    },
    setLayout(layout) {
      //this.$store.commit("SET_LAYOUT", layout);
      this.$store.dispatch("Layouts/set_layout", layout);
    },
    snackbarconf(snackbar, message, color) {
      snackbar.text = message;
      snackbar.color = color;
      snackbar.snackbar = true;
    },
    setShopDetails(){
      var shopLink = "https://" + this.shop_access_key + ".adeton.store";
      this.shopAccessDetails = {
        shoplink: shopLink,
        shopAccessKey: this.shop_access_key,
      }
      this.$store.dispatch("Auth/setShopAccess", this.shopAccessDetails);
    }
  },

  computed: {
    ...mapGetters({
      current_user: "Auth/CURRENT_USER",
      shopAccess: "Auth/SHOP_ACCESS",
      errors: "Auth/LOGIN_ERRORS",
      loading: "Auth/LOGIN_LOADING",
      settings: "settings/SETTINGS",
    }),
  },

  created() {
    this.shop_access_key = this.shopAccess.shopAccessKey
    this.setLayout("simple-layout");
  },
  watch: {
    // shop_access_key(sakey) {
     
    // },
    current_user(value) {
      if (typeof value != "undefined" || value != null) {
        var whologgedIn = value.user_details.role;
        if (whologgedIn == "administrator") {
          this.$router.push("/admin");
        } else if (whologgedIn == "accountant") {
          this.$router.push("/accountant");
        } else if (whologgedIn == "entry_clerk") {
          this.setLayout("sale-layout");
          this.$router.push("/e-clerk");
        } else {
          this.setLayout("sale-layout");
          this.$router.push("/sales");
        }
      }
    },
    errors(value) {
      //console.log('errrooosos',value)
      if (value != "" && value != "undefined") {
        var thesnackbar = this.$refs.sb;
        this.snackbarconf(thesnackbar, "Invalid email or password.", "error");
      }
    },
  },
};
</script>